/* eslint-disable no-bitwise */
export { DMS_MODULE } from '../constants';
export const NAME = 'ServisniSestavy';
export const API_NAME = 'Servis';
export const CRUMB_LABEL_KEY = 'StandRepDilna';


export enum RozsahDate {
	casDnes,
	casVcera,
	casTentoMesic,
	casMinulyMesic,
	casTentoRok,
	casMinulyRok,
	casMinulyKvart,
	casLibObdobi,
}

export enum AccessSestavyFlagEnum {
	NONE = 0,
	PRACOVNIK = 1,
	PROVOZOVNA = 2,
	S_ZAKAZKADRUH = 4,
	STREDNAKL = 8,
	VOZIDLO = 16,
	ZAKAZKA = 32,
	ZAKAZKALIST = 64,
	ZAKAZKAND = 128,
	ZAKAZKAPP = 256,
	ZAKAZKAPPROZ = 512,
	ZAKAZKAPPROZKOR = 1024,
	ZAKAZNIK = 2048,
	DOKLAD = 4096,
	DOKLADPOLOZ = 8192,
	VYROBEKVOZ = 16384,
	PUJCOVNAPA = 32768,
	PUJCOVNA = 65536,
	VOZIDLOPA = 131072
}
// #region Permisions
const zakazkaOtvorenaPermission = <const>AccessSestavyFlagEnum.PROVOZOVNA | AccessSestavyFlagEnum.S_ZAKAZKADRUH
	| AccessSestavyFlagEnum.VOZIDLO | AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKALIST
	| AccessSestavyFlagEnum.ZAKAZNIK;
const zakazkaRozpracovanaPermission = <const>AccessSestavyFlagEnum.PROVOZOVNA | AccessSestavyFlagEnum.S_ZAKAZKADRUH
	| AccessSestavyFlagEnum.VOZIDLO | AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKAND
	| AccessSestavyFlagEnum.ZAKAZKAPP;
const rozpracovanostMechanikuPermission = <const>AccessSestavyFlagEnum.PRACOVNIK | AccessSestavyFlagEnum.PROVOZOVNA
	| AccessSestavyFlagEnum.S_ZAKAZKADRUH | AccessSestavyFlagEnum.VOZIDLO | AccessSestavyFlagEnum.ZAKAZKA
	| AccessSestavyFlagEnum.ZAKAZKAPP;
const vyhodnoceniMechanikuPermission = <const>AccessSestavyFlagEnum.PRACOVNIK | AccessSestavyFlagEnum.PROVOZOVNA
	| AccessSestavyFlagEnum.S_ZAKAZKADRUH | AccessSestavyFlagEnum.STREDNAKL | AccessSestavyFlagEnum.VOZIDLO
	| AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKAPP | AccessSestavyFlagEnum.ZAKAZKAPPROZ;
const normocasOdpisPermission = <const>AccessSestavyFlagEnum.PRACOVNIK | AccessSestavyFlagEnum.PROVOZOVNA
	| AccessSestavyFlagEnum.S_ZAKAZKADRUH | AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKAPP
	| AccessSestavyFlagEnum.ZAKAZKAPPROZ;
const vyhodnoceniMechanikuDleZakazkyPermission = <const>AccessSestavyFlagEnum.PRACOVNIK | AccessSestavyFlagEnum.PROVOZOVNA
	| AccessSestavyFlagEnum.S_ZAKAZKADRUH | AccessSestavyFlagEnum.STREDNAKL | AccessSestavyFlagEnum.VOZIDLO
	| AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKAPP | AccessSestavyFlagEnum.ZAKAZKAPPROZ
	| AccessSestavyFlagEnum.ZAKAZKAPPROZKOR;
const odpisPPPermission = <const>AccessSestavyFlagEnum.PRACOVNIK | AccessSestavyFlagEnum.PROVOZOVNA
	| AccessSestavyFlagEnum.S_ZAKAZKADRUH | AccessSestavyFlagEnum.STREDNAKL | AccessSestavyFlagEnum.VOZIDLO
	| AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKAPPROZKOR;
const vynosCVPermission = <const>AccessSestavyFlagEnum.DOKLAD | AccessSestavyFlagEnum.DOKLADPOLOZ;
const vynosNdPermission = <const>AccessSestavyFlagEnum.DOKLAD | AccessSestavyFlagEnum.DOKLADPOLOZ;
const vymazaneZakazkyPermission = <const>AccessSestavyFlagEnum.PRACOVNIK | AccessSestavyFlagEnum.PROVOZOVNA
	| AccessSestavyFlagEnum.S_ZAKAZKADRUH | AccessSestavyFlagEnum.VOZIDLO | AccessSestavyFlagEnum.ZAKAZKA
	| AccessSestavyFlagEnum.ZAKAZKALIST | AccessSestavyFlagEnum.ZAKAZNIK | AccessSestavyFlagEnum.VYROBEKVOZ;
const zakazkaNdPermission = <const>AccessSestavyFlagEnum.DOKLAD | AccessSestavyFlagEnum.DOKLADPOLOZ;
const vozidlaDMZPermission = <const>AccessSestavyFlagEnum.ZAKAZKA | AccessSestavyFlagEnum.ZAKAZKALIST;
const PrehledTrzebDlePlatbyZaObdobiPermissions = <const>AccessSestavyFlagEnum.DOKLAD | AccessSestavyFlagEnum.DOKLADPOLOZ | AccessSestavyFlagEnum.PRACOVNIK;
const PrehledTrzebDilnyDleDokladuAZpusobuPlatbyPermission = <const>AccessSestavyFlagEnum.DOKLAD
	| AccessSestavyFlagEnum.DOKLADPOLOZ | AccessSestavyFlagEnum.PRACOVNIK;
const PrehledPracProTiskCarKoduPermission = <const>AccessSestavyFlagEnum.PRACOVNIK;
const TiskKoduWCasuPermission = <const>AccessSestavyFlagEnum.NONE;
const TiskPracovnichPrukazekPermission = <const>AccessSestavyFlagEnum.PRACOVNIK;
const KnihaJizdPermission = <const>AccessSestavyFlagEnum.PUJCOVNAPA | AccessSestavyFlagEnum.PUJCOVNA;
const VozidlaAutopujcovnyPermission = <const>AccessSestavyFlagEnum.VOZIDLOPA | AccessSestavyFlagEnum.VOZIDLO;
// #endregion


export const buttons = <const>[
	{ labelKey: 'cmdZakazkaOtev', routeName: 'OtevreneZakazky', api: 'GetZakazkaOtevrene', permission: zakazkaOtvorenaPermission },
	{ labelKey: 'cmdZakazkaRoz', routeName: 'RozpracovaneZakazky', api: 'GetRozpracPoZak', permission: zakazkaRozpracovanaPermission },
	{ labelKey: 'cmdRozpracovanostMech', routeName: 'RozpracovanostMechaniku', api: 'GetRozpracPoMech', permission: rozpracovanostMechanikuPermission },
	{ labelKey: 'cmdVyhodnoceniMech', routeName: 'VyhodnoceniMechaniku', api: 'GetVyhodnoceniMechanikuPoVyrobcich', permission: vyhodnoceniMechanikuPermission },
	{
		labelKey: 'cmdVyhodnoceniMechZakazky',
		routeName: 'VyhodnoceniMechanikuZakazky',
		api: 'GetVyhodnoceniMechanikuPoZakazkach',
		permission: zakazkaOtvorenaPermission,
	},
	// { labelKey: 'cmdOdpisPP', routeName: 'OdpisPP', api: '', permission: zakazkaOtvorenaPermission },
	// { labelKey: 'cmdNormocasOdpis', routeName: 'NormocasOdpis', api: '', permission: zakazkaOtvorenaPermission },
	// { labelKey: 'cmdVynosCV', routeName: 'VynosCV', api: '', permission: zakazkaOtvorenaPermission },
	// { labelKey: 'cmdVynosND', routeName: 'VynosND', api: '', permission: zakazkaOtvorenaPermission },
	// { labelKey: 'cmdZakazkaVymaz', routeName: 'ZakazkaVymaz', api: '', permission: zakazkaOtvorenaPermission },
	{ labelKey: 'cmdZakazkaND', routeName: 'ZakazkaND', api: 'GetPolozkyUctovaneNaZakazkuDleDruhu', permission: zakazkaNdPermission },
	{ labelKey: 'cmdVozidlaDZM', routeName: 'VozidlaDZM', api: 'GetVozidlaDzm', permission: vozidlaDMZPermission },
	{
		labelKey: 'cmdHotovost',
		routeName: 'PrehledTrzebDlePlatbyZaObdobi',
		api: 'GetPrehledTrzebDlePlatbyZaObdobi',
		permission: PrehledTrzebDlePlatbyZaObdobiPermissions,
	},
	{
		labelKey: 'cmdTrzbyVyuctZakaz', // +'cmdTrzbyVyuctZakazAddCM',
		routeName: 'PrehledTrzebDilnyDleDokladuAZpusobuPlatby',
		api: 'GetPrehledTrzebDilnyDleDokladuAZpusobuPlatby',
		permission: PrehledTrzebDilnyDleDokladuAZpusobuPlatbyPermission,
	},
	{
		labelKey: 'cmdSeznamPracCK',
		routeName: 'PrehledPracProTiskCarKodu',
		api: 'GetPrehledPracProTiskCarKodu',
		permission: PrehledPracProTiskCarKoduPermission,
	},
	{
		labelKey: 'cmdCasw',
		routeName: 'TiskKoduWCasu',
		api: 'GetTiskKoduWCasu',
		permission: TiskKoduWCasuPermission,
	},
	{
		labelKey: 'cmdPracovniPrukazka',
		routeName: 'TiskPracovnichPrukazek',
		api: 'GetTiskPracovnichPrukazek',
		permission: TiskPracovnichPrukazekPermission,
	},
	{
		labelKey: 'cmdKnihaJizd',
		routeName: 'KnihaJizd',
		api: 'GetKnihaJizd',
		permission: KnihaJizdPermission,
	},
	{
		labelKey: 'cmdVozidlopa',
		routeName: 'VozidlaAutopujcovny',
		api: 'GetVozidlaAutopujcovny',
		permission: VozidlaAutopujcovnyPermission,
	},
];

export type SestavaButton = { labelKey?: string, routeName: string, api: string, permission: number, text?: string };
